import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class TextImage {
    constructor(root) {
        this.root = root;
        this.text = this.root.querySelector('[data-text-image--text]');
        this.image = this.root.querySelectorAll('[data-text-image--image]');
        
        this.init();
    }

    init() {

        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.root,
                start: 'top 90%',
                end: 'bottom 10%',
                invalidateOnRefresh: true,
                // markers: true,
            },
        })
            .fromTo(this.text, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.3,
                ease: 'out',
            }, '#start')
            .fromTo(this.image, {
                opacity: 0,
                xPercent: () => {
                    let xPercent = this.root.getAttribute('data-text-image--reverse') !== null ? -10 : 10;
                    if (window.innerWidth < 768) { xPercent = 0; }

                    return xPercent;
                },
            }, {
                opacity: 1,
                xPercent: 0,
                duration: 0.7,
                stagger: 0.1,
                ease: 'out',
            }, '#start+=0.1');
    }

    destroy() {
        this.timeline && this.timeline.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-text-image]').length > 0;
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-text-image]').forEach(root => {
            const instance = new TextImage(root);
            this.instances.push(instance);
        });
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
